import type { Map as LeafletMap } from 'leaflet';

/**
 * Lee el bbox visible del mapa, o `null` si el contenedor todavía no
 * tiene tamaño real.
 *
 * Por qué existe: en el primer render Leaflet responde `getBounds()`
 * aunque el contenedor mida 0 de alto, y devuelve una franja degenerada
 * con sur === norte. Medido en producción:
 *
 *   bbox=-105.73,22.51255695405145,-95.22,22.51255695405145
 *
 * El API contestaba 0 resultados —correctamente, ese rectángulo no tiene
 * área— y el mapa público se quedaba vacío hasta que el visitante lo
 * movía. El mapa autenticado no lo sufría por casualidad: al resolverse
 * la sesión se cambia de componente y para entonces ya hay tamaño.
 */
export function readBbox(map: LeafletMap): string | null {
  const size = map.getSize();
  if (!size || size.x < 2 || size.y < 2) return null;

  const b = map.getBounds();
  const west = b.getWest();
  const south = b.getSouth();
  const east = b.getEast();
  const north = b.getNorth();
  if (![west, south, east, north].every(Number.isFinite)) return null;
  // Degenerado: sin alto o sin ancho no hay nada que consultar.
  if (north === south || east === west) return null;

  return `${west},${south},${east},${north}`;
}

/** Espera entre reintentos mientras el contenedor toma tamaño. */
export const BBOX_RETRY_MS = 120;
